module.exports = __webpack_public_path__ + "static/media/portal.e8bbb383.png";